import React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";

const CustomSelect = ({ data, value, handleChange, id }) => {
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  return (
    <Select
      labelId={id + "-label"}
      id={id}
      name={id}
      value={value}
      onChange={(e) => handleChange(e)}
      input={<OutlinedInput label={id} />}
      MenuProps={MenuProps}
    >
      <MenuItem
        value={0}
        sx={{
          color: "#b0b0b0",
          fontStyle: "italic",
        }}
      >
        Seçiniz
      </MenuItem>
      {data.map((item) => (
        <MenuItem key={item.id} value={item.id}>
          {item.name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default CustomSelect;
